import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import InputField from 'components/atoms/fields/InputField'
import SelectField from 'components/atoms/fields/SelectField'

import { timePickerSelectData, weekdays } from 'utils/helpers'

const GroupCourseSchedule = ({ fieldProps, disabled }) => {
  const { t } = useTranslation()

  return (
    <>
        <Grid
            container
            spacing={4}
            sx={{ marginTop: '0px' }}
          >
        { weekdays.map(w => ( 
          <Grid item xs={12} lg={6} key={w}>

              <Grid container sx={{ alignItems: 'center' }}>
                <Grid item xs={12} lg={2}>
                  { t(`weekdays.${w}`) }
                </Grid>
                <Grid item xs={6} lg={4}>
                  <SelectField
                    valueSelector='start_time'
                    fieldProps={{
                      label: t('common.start-time'),
                      name: `${fieldProps.name}[${w}]`,
                    }}
                    apiCall={() => timePickerSelectData()}
                    disabled={disabled}
                  />
                </Grid>
                <Grid item xs={6} lg={4} sx={{ paddingLeft: '10px' }}>
                  <InputField
                    valueSelector='duration_minutes'
                    fieldProps={{
                      label: t('common.duration-minutes'),
                      name: `${fieldProps.name}[${w}]`,
                    }}
                    disabled={disabled}
                  /> 
                </Grid> 
              </Grid>

          </Grid>
        ))
      }
      </Grid>
    </>
  )
}

export default GroupCourseSchedule
